/**
 * Палитра рядов графика — единственный источник цвета серии.
 *
 * До этого каждый экран заводил свой массив: «Партнёры» на одном графике были
 * синими, на другом зелёными, а часть слотов повторяла статусные цвета — читатель
 * принимал «жёлтый ряд» за предупреждение. Восемь слотов `--chart-1…--chart-8`
 * заведены во всех четырёх темах (index.css), проверены на цветовую слепоту и
 * НЕ пересекаются со статусными `--color-success/warning/danger/info`.
 *
 * Девятый ряд не изобретается: всё сверх восьмого получает приглушённый цвет
 * «Прочее». Если рядов регулярно больше восьми — это повод сгруппировать данные,
 * а не расширять палитру: девять и более различимых оттенков человек не удержит.
 */

export const CHART_SERIES = [
    'var(--chart-1)',
    'var(--chart-2)',
    'var(--chart-3)',
    'var(--chart-4)',
    'var(--chart-5)',
    'var(--chart-6)',
    'var(--chart-7)',
    'var(--chart-8)',
]

/** Цвет для рядов сверх восьмого — «Прочее». */
export const CHART_OTHER = 'var(--color-text-muted)'

/**
 * Цвет ряда по его порядковому номеру.
 * @param {number} index — 0-based позиция ряда.
 * @returns {string} CSS-значение цвета.
 */
export function seriesColor(index) {
    const i = Number.isFinite(index) ? Math.trunc(index) : 0
    if (i < 0 || i >= CHART_SERIES.length) return CHART_OTHER
    return CHART_SERIES[i]
}
